import { ShoppingCart, type LucideIcon } from "lucide-react";
import { formatPaise } from "../lib/cn";
import { Button } from "./Button";
import { cn } from "../lib/cn";

export interface StickyActionBarProps {
  totalItems: number;
  totalPaise: number;
  sublabel?: string;
  actionLabel?: string;
  actionIcon?: LucideIcon;
  onAction: () => void;
  className?: string;
}

export function StickyActionBar({
  totalItems,
  totalPaise,
  sublabel,
  actionLabel = "View Cart",
  actionIcon: ActionIcon = ShoppingCart,
  onAction,
  className,
}: StickyActionBarProps) {
  if (totalItems <= 0) return null;

  return (
    <div
      className={cn(
        "fixed inset-x-0 bottom-14 lg:bottom-0 z-30 border-t border-border bg-card/95 backdrop-blur-md shadow-overlay px-3 py-2.5 sm:px-6 transition-all",
        className
      )}
    >
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-3">
        <div className="flex items-center gap-2.5 min-w-0">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-tone-primary-soft text-tone-primary-text font-extrabold text-sm border border-tone-primary-border type-num">
            {totalItems}
          </div>
          <div className="min-w-0">
            <div className="flex items-center gap-1.5">
              <span className="text-sm sm:text-base font-extrabold text-foreground type-num">
                {formatPaise(totalPaise)}
              </span>
            </div>
            <p className="text-[11px] text-muted-foreground font-medium truncate">
              {sublabel ?? `${totalItems} ${totalItems === 1 ? "item" : "items"} in cart`}
            </p>
          </div>
        </div>

        <Button
          variant="primary"
          size="md"
          onClick={onAction}
          className="font-bold px-4 py-2 text-xs sm:text-sm shrink-0 shadow-sm bg-cta text-cta-foreground hover:opacity-95"
        >
          {ActionIcon && <ActionIcon className="h-4 w-4 mr-1.5 shrink-0" />}
          {actionLabel}
        </Button>
      </div>
    </div>
  );
}
